import * as t from '@/modules/auth/endpoints';
import Auth from '@/packages/Auth';
import { HTTPServiceClient } from '@/packages/http/service';
import {
  LoginFormData,
  SignupRequest,
  VerifyTfaRequest,
  GenerateTfaRequest,
  ForgotPasswordRequest,
  GenerateLoginOtpRequest,
  ValidateLoginOtpRequest
} from './types';
/**
 * --------------------------------------------------
 *	Authentication HTTP Serice
 * --------------------------------------------------
 **/
export const AuthService = {
  /**
   * Log in a User.
   * @param data {LoginFormData} Credentials from the login form.
   * @returns {Promise<LoginResponseData>} Auth Token and User Data.
   */
  async login(data: LoginFormData): Promise<any> {
    const res = await HTTPServiceClient.post(t.LOGIN_ENDPOINT, {
      email: data.email,
      password: data.password,
      retryToken: data.retryToken,
      rememberMe: data.rememberMe
    });

    return res.data;
  },

  /**
   * Checks if a token is valid.
   */
  async checkToken(token: string): Promise<any> {
    const res = await HTTPServiceClient.get(t.PASSWORD_TOKEN_ENDPOINT(token));

    return res.data;
  },

  /**
   * Resets.
   */
  async resetPassword(data: any): Promise<any> {
    const res = await HTTPServiceClient.post(
      t.PASSWORD_TOKEN_ENDPOINT(data.token),
      data
    );

    return res.data;
  },

  async forgotPassword(
    forgotPasswordRequest: ForgotPasswordRequest
  ): Promise<any> {
    const res = await HTTPServiceClient.post(
      t.FORGOT_PASSWORD_ENDPOINT,
      forgotPasswordRequest
    );
    return res.data;
  },

  async signup(signupRequest: SignupRequest): Promise<any> {
    const res = await HTTPServiceClient.post(
      t.SIGNUP_ENDPOINT(signupRequest.invitationCode),
      signupRequest
    );

    return res.data;
  },

  async validateInvitationCode(invitationCode: string): Promise<any> {
    const res = await HTTPServiceClient.get(
      t.VALIDATE_INVITE_ENDPOINT(invitationCode)
    );
    return res.data;
  },

  async impersonate(impersonationToken: string): Promise<any> {
    return await HTTPServiceClient.post(t.IMPERSONATE_ENDPOINT, {
      token: impersonationToken
    });
  },
  async verifyTfa(verifyRequest: VerifyTfaRequest): Promise<any> {
    const res = await HTTPServiceClient.post(
      t.VERIFY_TFA_ENDPOINT,
      verifyRequest
    );
    return res.data;
  },

  async generateTfa(generateRequest: GenerateTfaRequest): Promise<Response> {
    const res = await HTTPServiceClient.post(
      t.GENERATE_TFA_ENDPOINT,
      generateRequest
    );
    return res.data;
  },

  async validateRetryToken(impersonationToken: string): Promise<any> {
    return await HTTPServiceClient.get(
      t.VALIDATE_RETRY_TOKEN_ENDPOINT(impersonationToken)
    );
  },

  async generateLoginOtp(
    generateLoginOtpRequest: GenerateLoginOtpRequest
  ): Promise<Response> {
    const res = await HTTPServiceClient.post(
      t.GENERATE_LOGIN_OTP,
      generateLoginOtpRequest
    );
    return res.data;
  },

  async validateLoginOtp(
    validateLoginOtpRequest: ValidateLoginOtpRequest
  ): Promise<any> {
    const res = await HTTPServiceClient.post(
      t.VALIDATE_LOGIN_OTP,
      validateLoginOtpRequest
    );
    return res.data;
  },

  async refreshAuthToken(refreshToken: string): Promise<any> {
    const { data } = await HTTPServiceClient.post(t.REFRESH_TOKEN, {
      refreshToken
    });

    if (data?.token) {
      Auth.setToken(data?.token);
    }
    return data;
  },

  async generateLoginLink(email: string): Promise<Response> {
    const res = await HTTPServiceClient.post(t.GENERATE_LOGIN_LINK, { email });
    return res.data;
  },

  async validateLoginLink(token: string): Promise<any> {
    const res = await HTTPServiceClient.post(t.VALIDATE_LOGIN_LINK, {
      token
    });
    return res.data;
  }
};
